import * as React from "react";
import {cx} from "emotion";

import "./tree-item.scss";

import {cs}         from "@Common/react/chain-services";
import {csArr}      from "@Common/react/cs-arr";
import {keyed}      from "@Common/react/keyed";
import {UseState}   from "@Common/react/use-state";
import {isNotEmpty} from "@Common/utils/objects";

import {Checkbox} from "../../../../../../../../../common/design2/checkbox/checkbox";

export const TreeItem = ({code, description, children, selecting, next}) => cs(
    ["selected", (_, next) => next(selecting.isSelected(code))],
    ({selected}) => next({
        select: () => selecting.select(code),
        unselect: () => selecting.unselect(code),
        selected,
        render: ({passiveSelected, onPassiveUnselect, onSelect}) => cs(
            ["hoveringExpandIndicator", (_, next) => UseState({next})],
            // ["selected", (_, next) => next(selecting.isSelected(code))],
            ["midwaySelected", (_, next) => next(selecting.isMidwaySelected(code))],
            ["expanded", (_, next) => UseState({next})],
            ({hoveringExpandIndicator, expanded, midwaySelected}) => <>
                <div className={cx("tree-item-1lw line")}>
                    <div {...{
                        className: "expand-indicator",
                        onMouseEnter: () => hoveringExpandIndicator.onChange(true),
                        onMouseLeave: () => hoveringExpandIndicator.onChange(false),
                    }}>
                        {isNotEmpty(children) && (
                            !expanded.value ? (
                                <i className="fa fa-plus-square"  onClick={() => expanded.onChange(true)}/>
                            ) : (
                                <i className="fa fa-minus-square" onClick={() => expanded.onChange(false)}/>
                            )
                        )}
                    </div>
                    {Checkbox({
                        checked: (
                            selected || passiveSelected ? (
                                true
                            ) : midwaySelected ? (
                                "midway"
                            ) : (
                                false
                            )
                        ),
                        onClick: () => (
                            (selected || passiveSelected) ? (
                                selected ? (
                                    selecting.unselect(code)
                                ) : (
                                    onPassiveUnselect()
                                )
                            ) : (
                                midwaySelected ? (() => {
                                    selecting.clearChildren(code);
                                    onSelect();
                                })() : (
                                    onSelect()
                                )
                            )
                        ),
                        xdQaName: code + " - " + description,
                    })}

                    <div className="label-wrapper">
                        {cs(
                            ["label", (_, next) => next(`${code} - ${description}`)],
                            ({label}) => (
                                <div className="label" title={label}>
                                    {label}
                                </div>
                            )
                        )}
                    </div>
                </div>

                {isNotEmpty(children) && expanded.value && cs(
                    ["items", ({}, next) => csArr(
                        Object.values(children ?? {}).map(({code, description, children}) => (next) => TreeItem({
                            code, description, children, selecting,
                            next,
                        })),
                        next,
                    )],
                    ({items}) => (
                        <div className={cx("tree-item-1lw children", {highlight: hoveringExpandIndicator.value})}>
                            <div {...{
                                className: "vertical-line",
                                onMouseEnter: () => hoveringExpandIndicator.onChange(true),
                                onMouseLeave: () => hoveringExpandIndicator.onChange(false),
                            }}/>
                            {items.map((item, i) => cs(
                                keyed(i),
                                () => item.render({
                                    passiveSelected: selected || passiveSelected,
                                    onPassiveUnselect: () => {
                                        for (const item1 of items) {
                                            if (item1 !== item) {
                                                item1.select();
                                            }
                                        }

                                        if (passiveSelected) {
                                            onPassiveUnselect();
                                        } else {
                                            selecting.unselect(code);
                                        }
                                    },
                                    onSelect: () => {
                                        if (!items.some((item1) => item1 !== item && !item1.selected)) {
                                            // Now all children are selected, let's clear all and mark the parent selected
                                            for (const item1 of items) {
                                                if (item1 !== item) {
                                                    item1.unselect();
                                                }
                                            }
                                            onSelect();
                                        } else {
                                            item.select();
                                        }
                                    },
                                }),
                            ))}
                        </div>
                    ),
                )}
            </>,
        ),
    }),
);
